var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-language"},[_c('img',{staticClass:"app-language-icon",attrs:{"src":require("@/assets/img/china-flag.png"),"alt":"国旗"}}),_vm._v(" "),_c('span',{staticClass:"app-language-name"},[_vm._v("CN")])])
}]

export { render, staticRenderFns }